import { render } from "./RegistryDetails.vue?vue&type=template&id=5bf38749"
import script from "./RegistryDetails.vue?vue&type=script&lang=js"
export * from "./RegistryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__